export default {
	$accessibility: {
		archived: "الأرشيف",
		present: "الحاضر",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "مخفي عن المستلم",
			hidden_from_sender: "مخفي عن المرسل",
			private: "خاص",
			shared_with_custom: "مشارك مع مخصص",
			shared_with_everyone: "مشارك مع الجميع",
			shared_with_receiver: "مشارك مع المستلم",
			shared_with_sender: "مشارك مع المرسل",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit} جيجابايت تخزين",
		limitMBStorage: "{limit} ميجابايت تخزين",
		limitUser: "{limit} مستخدم",
		limitUsers: "{limit} مستخدمين",
		renewAtPricePerUnit: "سيتم التجديد بـ {currency}{price} لكل {unit}",
		unlimitedModule: "غير محدود {module}",
		upToLimitModule: "حتى {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, تركيا",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sar!2str!4v1701805110461!5m2!1sar!2str",
		name: "شركة سلوش سوفتوير",
		phoneNumber: "+90 (555) 444-33-22",
		slogan: "عزز عملك مع Antrego. إدارة عمليات الشحن الخاصة بك رقمياً، بأمان، وبسهولة.",
	},
	$cookieBanner: {
		accept: "قبول",
		decline: "رفض",
		message:
			"نستخدم ملفات تعريف الارتباط والتقنيات المماثلة للتحليلات والمحتوى المخصص. بالنقر على 'قبول'، فإنك توافق على استخدامنا لهذه التقنيات.",
	},
	$country: {
		afghanistan: "أفغانستان",
		aland: "آلاند",
		albania: "ألبانيا",
		algeria: "الجزائر",
		american_samoa: "ساموا الأمريكية",
		andorra: "أندورا",
		angola: "أنغولا",
		anguilla: "أنغيلا",
		antarctica: "أنتاركتيكا",
		antigua_and_barbuda: "أنتيغوا وباربودا",
		argentina: "الأرجنتين",
		armenia: "أرمينيا",
		aruba: "أروبا",
		australia: "أستراليا",
		austria: "النمسا",
		azerbaijan: "أذربيجان",
		bahamas: "الباهاما",
		bahrain: "البحرين",
		bangladesh: "بنغلاديش",
		barbados: "بربادوس",
		belarus: "بيلاروس",
		belgium: "بلجيكا",
		belize: "بليز",
		benin: "بنين",
		bermuda: "برمودا",
		bhutan: "بوتان",
		bolivia: "بوليفيا",
		bonaire_sint_eustatius_and_saba: "بونير، سينت أوستاتيوس، وسابا",
		bosnia_and_herzegovina: "البوسنة والهرسك",
		botswana: "بوتسوانا",
		bouvet_island: "جزيرة بوفيت",
		brazil: "البرازيل",
		british_indian_ocean_territory: "إقليم المحيط الهندي البريطاني",
		british_virgin_islands: "جزر العذراء البريطانية",
		brunei: "بروناي",
		bulgaria: "بلغاريا",
		burkina_faso: "بوركينا فاسو",
		burundi: "بوروندي",
		cabo_verde: "كابو فيردي",
		cambodia: "كمبوديا",
		cameroon: "الكاميرون",
		canada: "كندا",
		cayman_islands: "جزر كايمان",
		central_african_republic: "جمهورية أفريقيا الوسطى",
		chad: "تشاد",
		chile: "تشيلي",
		china: "الصين",
		christmas_island: "جزيرة كريسماس",
		cocos_islands: "جزر كوكوس [كيلينغ]",
		colombia: "كولومبيا",
		comoros: "جزر القمر",
		congo_republic: "جمهورية الكونغو",
		cook_islands: "جزر كوك",
		costa_rica: "كوستاريكا",
		croatia: "كرواتيا",
		cuba: "كوبا",
		curacao: "كوراساو",
		cyprus: "قبرص",
		czechia: "التشيك",
		denmark: "الدنمارك",
		djibouti: "جيبوتي",
		dominica: "دومينيكا",
		dominican_republic: "جمهورية الدومينيكان",
		dr_congo: "جمهورية الكونغو الديمقراطية",
		ecuador: "الإكوادور",
		egypt: "مصر",
		el_salvador: "السلفادور",
		equatorial_guinea: "غينيا الاستوائية",
		eritrea: "إريتريا",
		estonia: "إستونيا",
		eswatini: "إيسواتيني",
		ethiopia: "إثيوبيا",
		falkland_islands: "جزر فوكلاند",
		faroe_islands: "جزر فارو",
		fiji: "فيجي",
		finland: "فنلندا",
		france: "فرنسا",
		french_guiana: "غويانا الفرنسية",
		french_polynesia: "بولينيزيا الفرنسية",
		french_southern_territories: "الأقاليم الجنوبية الفرنسية",
		gabon: "الغابون",
		gambia: "غامبيا",
		georgia: "جورجيا",
		germany: "ألمانيا",
		ghana: "غانا",
		gibraltar: "جبل طارق",
		greece: "اليونان",
		greenland: "غرينلاند",
		grenada: "غرينادا",
		guadeloupe: "غوادلوب",
		guam: "غوام",
		guatemala: "غواتيمالا",
		guernsey: "غيرنزي",
		guinea: "غينيا",
		guinea_bissau: "غينيا بيساو",
		guyana: "غيانا",
		haiti: "هايتي",
		heard_island_and_mcdonald_islands: "جزيرة هيرد وجزر ماكدونالد",
		honduras: "هندوراس",
		hong_kong: "هونغ كونغ",
		hungary: "هنغاريا",
		iceland: "آيسلندا",
		india: "الهند",
		indonesia: "إندونيسيا",
		iran: "إيران",
		iraq: "العراق",
		ireland: "أيرلندا",
		isle_of_man: "جزيرة مان",
		israel: "إسرائيل",
		italy: "إيطاليا",
		ivory_coast: "ساحل العاج",
		jamaica: "جامايكا",
		japan: "اليابان",
		jersey: "جيرزي",
		jordan: "الأردن",
		kazakhstan: "كازاخستان",
		kenya: "كينيا",
		kiribati: "كيريباس",
		kosovo: "كوسوفو",
		kuwait: "الكويت",
		kyrgyzstan: "قرغيزستان",
		laos: "لاوس",
		latvia: "لاتفيا",
		lebanon: "لبنان",
		lesotho: "ليسوتو",
		liberia: "ليبيريا",
		libya: "ليبيا",
		liechtenstein: "ليختنشتاين",
		lithuania: "ليتوانيا",
		luxembourg: "لوكسمبورغ",
		macao: "ماكاو",
		madagascar: "مدغشقر",
		malawi: "مالاوي",
		malaysia: "ماليزيا",
		maldives: "المالديف",
		mali: "مالي",
		malta: "مالطا",
		marshall_islands: "جزر مارشال",
		martinique: "مارتينيك",
		mauritania: "موريتانيا",
		mauritius: "موريشيوس",
		mayotte: "مايوت",
		mexico: "المكسيك",
		micronesia: "ميكرونيزيا",
		moldova: "مولدوفا",
		monaco: "موناكو",
		mongolia: "منغوليا",
		montenegro: "الجبل الأسود",
		montserrat: "مونتسيرات",
		morocco: "المغرب",
		mozambique: "موزمبيق",
		myanmar: "ميانمار",
		namibia: "ناميبيا",
		nauru: "ناورو",
		nepal: "نيبال",
		netherlands: "هولندا",
		new_caledonia: "كاليدونيا الجديدة",
		new_zealand: "نيوزيلندا",
		nicaragua: "نيكاراغوا",
		niger: "النيجر",
		nigeria: "نيجيريا",
		niue: "نيوي",
		norfolk_island: "جزيرة نورفولك",
		north_korea: "كوريا الشمالية",
		north_macedonia: "شمال مقدونيا",
		northern_mariana_islands: "جزر ماريانا الشمالية",
		norway: "النرويج",
		oman: "عمان",
		pakistan: "باكستان",
		palau: "بالاو",
		palestine: "فلسطين",
		panama: "بنما",
		papua_new_guinea: "بابوا غينيا الجديدة",
		paraguay: "باراغواي",
		peru: "بيرو",
		philippines: "الفلبين",
		pitcairn_islands: "جزر بيتكيرن",
		poland: "بولندا",
		portugal: "البرتغال",
		puerto_rico: "بورتوريكو",
		qatar: "قطر",
		reunion: "ريونيون",
		romania: "رومانيا",
		russia: "روسيا",
		rwanda: "رواندا",
		saint_barthelemy: "سانت بارتيليمي",
		saint_helena: "سانت هيلينا",
		saint_lucia: "سانت لوسيا",
		saint_martin: "سانت مارتن",
		saint_pierre_and_miquelon: "سان بيير وميكلون",
		samoa: "ساموا",
		san_marino: "سان مارينو",
		sao_tome_and_principe: "ساو تومي وبرينسيبي",
		saudi_arabia: "السعودية",
		senegal: "السنغال",
		serbia: "صربيا",
		seychelles: "سيشل",
		sierra_leone: "سيراليون",
		singapore: "سنغافورة",
		sint_maarten: "سانت مارتن",
		slovakia: "سلوفاكيا",
		slovenia: "سلوفينيا",
		solomon_islands: "جزر سليمان",
		somalia: "الصومال",
		south_africa: "جنوب أفريقيا",
		south_georgia_and_south_sandwich_islands: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
		south_korea: "كوريا الجنوبية",
		south_sudan: "جنوب السودان",
		spain: "إسبانيا",
		sri_lanka: "سريلانكا",
		st_kitts_and_nevis: "سانت كيتس ونيفيس",
		st_vincent_and_grenadines: "سانت فنسنت وجزر غرينادين",
		sudan: "السودان",
		suriname: "سورينام",
		svalbard_and_jan_mayen: "سفالبارد ويان ماين",
		sweden: "السويد",
		switzerland: "سويسرا",
		syria: "سوريا",
		taiwan: "تايوان",
		tajikistan: "طاجيكستان",
		tanzania: "تنزانيا",
		thailand: "تايلاند",
		timor_leste: "تيمور الشرقية",
		togo: "توغو",
		tokelau: "توكيلاو",
		tonga: "تونغا",
		trinidad_and_tobago: "ترينيداد وتوباغو",
		tunisia: "تونس",
		turkiye: "تركيا",
		turkmenistan: "تركمانستان",
		turks_and_caicos_islands: "جزر تركس وكايكوس",
		tuvalu: "توفالو",
		uganda: "أوغندا",
		ukraine: "أوكرانيا",
		united_arab_emirates: "الإمارات العربية المتحدة",
		united_kingdom: "المملكة المتحدة",
		united_states: "الولايات المتحدة",
		uruguay: "أوروغواي",
		us_minor_outlying_islands: "جزر الولايات المتحدة البعيدة الصغيرة",
		us_virgin_islands: "جزر العذراء الأمريكية",
		uzbekistan: "أوزبكستان",
		vanuatu: "فانواتو",
		vatican_city: "الفاتيكان",
		venezuela: "فنزويلا",
		vietnam: "فيتنام",
		wallis_and_futuna: "واليس وفوتونا",
		western_sahara: "الصحراء الغربية",
		yemen: "اليمن",
		zambia: "زامبيا",
		zimbabwe: "زيمبابوي",
	},
	$currency: {
		euro: "اليورو",
		turkish_lira: "الليرة التركية",
		us_dollar: "الدولار الأمريكي",
	},
	$documentManager: {
		message_1: 'لتعديل القالب، انقر فوق زر "تعديل القالب" للانتقال إلى شاشة التحرير.',
		message_2: 'يمكنك تغيير عدد الصفوف في القائمة عن طريق زيادة أو تقليل "عدد الصفوف".',
		message_3: 'سيتم عرض التغييرات التي أجريتها في حقول المحتوى على الفور في قسم "المعاينة".',
		message_4: 'لإنشاء ملف PDF، انقر فوق زر "إجراءات المستند" لحفظه كملف PDF.',
		message_5: 'للوصول إلى المستندات لاحقًا، يمكنك حفظها من خلال زر "إجراءات المستند".',
		message_6: "سيتم عرض البيانات المدخلة في كل خلية من الجدول في المعاينة كما هي.",
		message_7: "يمكن تحرير الجدول البياني كما لو كان ملف Excel أو جدول بيانات إلكتروني.",
	},
	$employeeType: {
		admin: "مدير",
		default: "افتراضي",
		exporter: "مُصدّر",
		importer: "مُستورد",
	},
	$format: {
		date: "DD/MM/YYYY",
		date_time: "DD/MM/YYYY HH:mm:ss",
		date_time_without_second: "DD/MM/YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "أنشئ شركتك هنا.",
			create_company_title: "هل ترغب في إضافة شركتك؟",
			description: "لقد سجلت الدخول بنجاح. الآن تحتاج إلى الانضمام إلى شركة أو إنشاء شركة جديدة.",
			join_company_subtitle: "أدخل رمزك وانضم إلى الشركة هنا.",
			join_company_title: "هل ترغب في الانضمام إلى شركة موجودة؟",
			title: "مرحبًا {name}",
		},
		$unauthorized: {
			description: "تحكم في عمليات الاستيراد والتصدير باستخدام Antrego",
			forget_password_subtitle: "يرجى إدخال بريدك الإلكتروني لإعادة تعيين كلمة المرور.",
			sign_in_subtitle: "سجل الدخول هنا",
			sign_in_title: "هل لديك حساب؟",
			sign_up_subtitle: "اشترك هنا",
			sign_up_title: "هل ترغب في إنشاء حساب؟",
			title: "مرحبًا بك في Antrego",
		},
	},
	$invitationType: {
		company_partner: "دعوة التعاون التجاري",
		customs_partner: "دعوة شريك الجمارك",
		employee: "دعوة الموظف",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "حوِّل عمليات عملك",
				hero_subtitle: "مزايا المنصة",
				hero_description:
					"اكتشف كيف تُبسّط Antrego سير عملك اللوجستي بالكامل، من إدارة المخزون إلى تتبع الشحنات. اختبر كفاءة أعلى، وتكاليف أقل، وتعاونًا أفضل عبر مؤسستك.",
				features_title: "مزايا المنصة الشاملة",
				feature_1_title: "لوحة معلومات مركزية",
				feature_1_desc: "الوصول إلى جميع بياناتك اللوجستية من شحنات ومخزون ومستندات من واجهة واحدة سهلة الاستخدام.",
				feature_2_title: "دقة بيانات مُحسّنة",
				feature_2_desc: "قلّل الأخطاء عبر الإدخال الآلي للبيانات والتحقق منها والمزامنة الفورية بين جميع الوحدات.",
				feature_3_title: "توفير الوقت",
				feature_3_desc: "وفّر ساعات يوميًا بفضل سير العمل المؤتمت والتنبيهات الذكية والعمليات المبسطة.",
				feature_4_title: "تعاون الفريق",
				feature_4_desc: "فعّل تعاونًا سلسًا بين الفرق الداخلية والعملاء والمورّدين وشركاء الخدمات اللوجستية.",
				feature_5_title: "خفض التكاليف",
				feature_5_desc: "قلّل التكاليف التشغيلية من خلال تحسين الكفاءة وتقليل الأخطاء وتحسين تخصيص الموارد.",
				feature_6_title: "قابلية التوسع",
				feature_6_desc: "نمِّ عملك بثقة مع منصة تتوسع بسهولة مع احتياجاتك.",
				benefits_title: "لماذا تختار Antrego؟",
				benefit_1: "رؤية شاملة عبر سلسلة الإمداد بالكامل",
				benefit_2: "منصة سحابية آمنة بتشفير على مستوى المؤسسات",
				benefit_3: "تصميم متجاوب للهواتف للوصول أثناء التنقل",
				benefit_4: "تنبيهات آلية تُبقي جميع الأطراف على اطلاع",
				benefit_5: "سير عمل قابل للتخصيص يتكيّف مع عملياتك",
				benefit_6: "فريق دعم مخصص يضمن نجاحك",
				workflow_title: "كيف تُحوّل Antrego عملياتك",
				step_1_title: "وحِّد عملياتك",
				step_1_desc:
					"اجمع إدارة المخزون وتتبع الشحنات والتعامل مع المستندات والتواصل مع العملاء في منصة متكاملة واحدة.",
				step_2_title: "أتمِت المهام الروتينية",
				step_2_desc:
					"دع Antrego تتولى المهام المتكررة مثل إدخال البيانات والتنبيهات وتحديثات الحالة لتتفرغ فرقك للعمل الاستراتيجي.",
				step_3_title: "مكّن التعاون الفوري",
				step_3_desc: "شارك المعلومات فورًا مع جميع الأطراف لضمان حصول الجميع على أحدث التحديثات والمستندات.",
				step_4_title: "اتخذ قرارات مبنية على البيانات",
				step_4_desc: "استفد من التحليلات والتقارير الشاملة لتحديد الاتجاهات وتحسين العمليات ودفع التحسين المستمر.",
				cta_title: "جاهز لتحويل عملياتك اللوجستية؟",
				cta_button: "ابدأ مجانًا اليوم",
				cta_subtitle: "لا حاجة لبطاقة ائتمان • انضم إلى أكثر من 500 شركة",
			},
			benefits_title: "مزايا المنصة",
			business_process: "يسرع عمليات العمل الخاصة بك.",
			control_title: "تحكم مع Antrego.",
			highlight_word: "تحكم",
			risk_of_error: "يقلل من خطر الأخطاء.",
			text: "تعمل Antrego على تحويل عمليات الخدمات اللوجستية للمُصدّرين والمستوردين ووكلاء الشحن والمصنّعين من خلال حلول رقمية متكاملة لإدارة المخزون وتتبع الشحنات في الوقت الفعلي وأتمتة المستندات.",
			time_and_cost_savings: "يوفر الوقت والتكاليف.",
		},
		$content: {
			$text: {
				0: "تتبع جميع شحناتك في مكان واحد، وتحكم في أموالك من خلال تقارير ديناميكية.",
				1: "شارك تحديثاتك في الوقت الفعلي مع عملائك لتحسين جودة خدماتك.",
				2: "عرض ومشاركة جميع الوثائق المتعلقة بشحنتك في نظام واحد.",
				3: "تحكم في عمليتك بسهولة من خلال الوصول إلى Antrego من جميع الأجهزة والمواقع.",
				4: "قم بتخزين جميع بياناتك باستخدام تقنية التشفير SHA-256. اطمئن من حيث الأمان.",
				5: "قم بالتتبع المشترك مع جميع أصحاب المصلحة في عملية العمل. إدارة العملية بشكل أكثر فعالية.",
			},
			$title: {
				0: "إدارة الشحنات من الطرف إلى الطرف",
				1: "تواصل فوري مع العملاء",
				2: "إدارة مستندات مركزية",
				3: "وصول سحابي من أي مكان",
				4: "أمان بمستوى المؤسسات",
				5: "تعاون متعدد الأطراف",
			},
			content_title: "كل ما تحتاجه في منصة واحدة",
		},
		$home: {
			subtitle: "أدِر المخزون والشحنات والمستندات والتتبع في منصة قوية واحدة",
			text: "وفّر 40% من الوقت التشغيلي مع سير عمل مؤتمت. انضم إلى أكثر من 500 شركة تُبسّط عملياتها اللوجستية عالميًا.",
			title: "منصة لوجستية متكاملة: من المخزون إلى التسليم",
		},
		$lifecycle: {
			headline: "العملية",
			info_button: "الحصول على المعلومات",
			lifecycle_texts: {
				0: "قم بتحميل ملفات إضافية لإنشاء فاتورتك المبدئية وشاركها على الفور مع عميلك.",
				1: "أدخل تفاصيل شحنتك وأضف المستندات. قم بإخطار عميلك وادير جميع عمليات الشحن المشتركة من خلال قناة واحدة.",
				2: "تتبع وضعك المالي المتعلق بالاستيراد والتصدير في الوقت الفعلي.",
			},
			lifecycle_titles: {
				0: "تسجيل الدخول وإنشاء الفاتورة المبدئية",
				1: "إنشاء الشحنة",
				2: "تتبع الأنشطة المالية",
			},
			productivity_title: "زيادة الإنتاجية وتقليل التعقيد والأخطاء في 3 خطوات.",
			tracking_guide_title: "دليل التتبع السهل",
		},
		$logistics: {
			logistics_title: "أنواع الخدمات اللوجستية المدعومة",
			solutions_title: "الحل المناسب لكل حمولة",
			text: "مع Antrego، شريكك الرقمي في جميع أنواع النقل، نقف بجانبك في جميع حركاتك العالمية.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "إنشاء مستندات PDF احترافية",
				hero_subtitle: "أنشئ مستندات تجارية رائعة خلال دقائق",
				hero_description:
					"يمكّنك مُنشئ PDF البديهي من Antrego من تصميم وتخصيص وإنشاء فواتير وفواتير أولية ومستندات تجارية احترافية بسهولة—دون الحاجة لمهارات تصميم.",
				features_title: "كل ما تحتاجه لإنشاء مستندات احترافية",
				feature_1_title: "محرر بالسحب والإفلات",
				feature_1_desc: "واجهة سهلة لإضافة النصوص والصور والشعارات والجداول عبر السحب والإفلات—دون مهارات تقنية.",
				feature_2_title: "قوالب مخصصة",
				feature_2_desc: "اختر من قوالب جاهزة أو أنشئ تنسيقاتك ذات العلامة التجارية. احفظ القوالب لاتساق الهوية.",
				feature_3_title: "حقول نماذج ذكية",
				feature_3_desc: "املأ بيانات العملاء والمنتجات والأسعار تلقائيًا. اتصل مباشرة ببيانات الشحن والمخزون.",
				feature_4_title: "تخصيص العلامة التجارية",
				feature_4_desc: "أضف شعار شركتك واختر الألوان والخطوط لإنشاء مستندات تعكس هويتك تمامًا.",
				feature_5_title: "تصدير بصيغ متعددة",
				feature_5_desc:
					"نزّل كملف PDF أو اطبع مباشرة أو شارك عبر البريد الإلكتروني—جميع المستندات منسقة باحتراف وجاهزة للطباعة.",
				feature_6_title: "التحكم في الإصدارات",
				feature_6_desc: "تتبّع المراجعات واحفظ السجل وارجع للإصدارات السابقة. لا تفقد أي نسخة مهمة.",
				benefits_title: "لماذا تختار مُنشئ PDF من Antrego؟",
				benefit_1: "أنشئ مستندات احترافية أسرع 10 مرات من الطرق التقليدية",
				benefit_2: "حافظ على اتساق علامتك عبر جميع المستندات التجارية",
				benefit_3: "قلّل الأخطاء بفضل تعبئة البيانات الآلية من الشحنات",
				benefit_4: "وفّر الوقت باستخدام القوالب القابلة لإعادة الاستخدام والنماذج الذكية",
				benefit_5: "أبهِر العملاء بمستندات مصقولة واحترافية",
				benefit_6: "الوصول إلى مستنداتك في أي وقت ومن أي جهاز",
				workflow_title: "كيف تعمل عملية إنشاء PDF",
				step_1_title: "اختر القالب",
				step_1_desc: "اختر من قوالب مُعَدّة مسبقًا أو ابدأ من صفحة فارغة لتصميم تخطيطك المخصص.",
				step_2_title: "خصِّص المحتوى",
				step_2_desc: "اسحب وأفلت العناصر، أضف شعارك وهويتك، واملأ الحقول تلقائيًا ببيانات الشحن.",
				step_3_title: "عاين وعدّل",
				step_3_desc: "راجع مستندك في الوقت الفعلي وأجرِ التعديلات وتأكد من اكتماله قبل الإنشاء.",
				step_4_title: "أنشئ وشارِك",
				step_4_desc:
					"نزّل كملف PDF أو أرسِل عبر البريد مباشرة للعملاء أو أرفِقه بالشحنات. احفظ القالب للاستخدام مستقبلاً.",
				cta_title: "ابدأ إنشاء مستندات احترافية اليوم",
				cta_button: "ابدأ مجانًا",
				cta_subtitle: "لا حاجة لبطاقة ائتمان • ابدأ خلال دقائق",
			},
			description:
				"محرر PDF الخاص بنا هو أداة قوية تجعل إنشاء وتعديل الفواتير أكثر سهولة. وفر الوقت وقدم مستندات بمظهر احترافي لشركائك التجاريين.",
			features: {
				design: "تصميم الفاتورة: أضف شعارك، عدّل الألوان، وخصص شكل الفاتورة.",
				edit: "تحرير المستندات: قم بسرعة بتعديل ملفات PDF، أضف أو أزل النصوص.",
				shareSave: "المشاركة والحفظ: قم بتنزيل المستندات التي أنشأتها، شاركها أو خزّنها مباشرة على المنصة.",
			},
			longTitle: "فواتير سريعة ومخصصة باستخدام محرر PDF.",
			note: "يسمح هذا الإعداد للمستخدمين باستكشاف الميزات بصرياً ومراجعة المزايا كتابياً.",
			title: "إعداد الفواتير أصبح سهلاً للغاية!",
		},
		$process: {
			comparison_subtitle: "شاهد الفرق بين الإدارة التقليدية والرقمية للوجستيات",
			digital_future: "ابتعد عن الأساليب التقليدية وادخل إلى المستقبل الرقمي",
			digital_shipping: "تتبع الشحنات الرقمية مع Antrego",
			digital_shipping_texts: {
				0: "يتم إنشاء الفواتير المبدئية للطلبات الواردة وتتبعها بسهولة عبر قناة واحدة.",
				1: "يتم إرسال الفواتير المبدئية، ويتم إرسال الإشعارات إلى العميل فورًا، ويتم الموافقة عليها من خلال Antrego.",
				2: "تتم إدارة عمليات المستندات من خلال Antrego. لا تضيع، ولا تحدث تأخيرات، ويتم تقليل احتمالية حدوث أخطاء.",
				3: "يمكن للموردين والعملاء ووكلاء الجمارك رؤية تفاصيل الشحنة وتتبعها بشكل مشترك على الفور.",
				4: "يتم إنشاء التقارير المالية تلقائيًا شهريًا وسنويًا.",
			},
			question_title: "كيف توفّر لك Antrego أكثر من 10 ساعات أسبوعيًا",
			tracking_method: "قم برقمنة طرق التتبع الخاصة بك وسرّع عملياتك.",
			traditional_shipping: "تتبع الشحنات التقليدي",
			traditional_shipping_texts: {
				0: "يتم جمع الطلبات عبر البريد الإلكتروني أو الرسائل أو الهاتف من خلال قنوات مختلفة، مما يسبب صعوبات في التتبع الداخلي.",
				1: "يتم إنشاء الفاتورة المبدئية باستخدام أدوات مثل Excel، وتتم عملية الموافقة يدويًا عبر البريد الإلكتروني أو WhatsApp أو الهاتف.",
				2: "تؤدي العمليات اليدوية للمستندات إلى حدوث أخطاء وتأخيرات، مما يتسبب في خسائر في الوقت والمال.",
				3: "لا توجد منصة مشتركة للموردين والعملاء ووكلاء الجمارك لتتبع تفاصيل الشحنة.",
				4: "يتم فحص البيانات المالية بشكل فردي بعد كل شحنة، مما يجعل إعداد التقارير صعبًا.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego منصة شاملة لإدارة الخدمات اللوجستية تساعد الشركات على تتبع الشحنات وإدارة المخزون والتعاون مع العملاء في الوقت الفعلي. تُحوّل العملية بأكملها من المخزون إلى التسليم إلى صيغة رقمية.</p>",
				1: "<p>تُبسّط Antrego اللوجستيات عبر سهولة الوصول من أي جهاز، وأمان بيانات بمستوى المؤسسات باستخدام تشفير SHA-256، وتتبع مشترك يُبقي جميع الأطراف على اطلاع طوال رحلة الشحنة.</p>",
				2: "<p>تدعم Antrego جميع أنماط النقل الرئيسية بما في ذلك الشحن البحري والشحن الجوي والنقل البري والسكك الحديدية. نعمل مع جميع الناقلين وخطوط الشحن الكبرى حول العالم.</p>",
				3: "<p>توفر Antrego خطة مجانية لما يصل إلى 10 شحنات شهريًا دون الحاجة لبطاقة ائتمان. تبدأ الخطط المميزة من 99 دولارًا/شهر للشحنات غير المحدودة، مع توفير 16% عند الدفع السنوي. راجع صفحة التسعير للتفاصيل الكاملة.</p>",
				4: "<p>نقوم حاليًا بتطوير الوصول عبر واجهات برمجة التطبيقات والتكامل مع أنظمة اللوجستيات وERP الشائعة. تُخطط ميزات التكامل للإصدارات المستقبلية. اتصل بنا لمعرفة المزيد عن خارطة الطريق والميزات القادمة.</p>",
				5: "<p>تبدأ معظم الشركات العمل خلال 24 ساعة. يستغرق الإعداد الأساسي 5–10 دقائق فقط لإنشاء الحساب وإضافة معلومات الشركة. يساعدك فريق الإعداد لدينا على استيراد البيانات وتخصيص سير العمل.</p>",
			},
			$title: {
				0: "ما هي Antrego؟",
				1: "لماذا يجب أن أستخدم Antrego؟",
				2: "ما أنواع الخدمات اللوجستية التي تدعمها Antrego؟",
				3: "كم تُكلّف Antrego؟",
				4: "هل يمكنني دمج Antrego مع أنظمتي الحالية؟",
				5: "كم يستغرق إعداد Antrego؟",
			},
			save_percentage: "وفر 16٪ شهريًا",
			text: "يمكنك الوصول إلى جميع المعلومات بسهولة باستخدام Antrego، ولا تتردد في الاتصال بنا لأي استفسارات أخرى.",
			title: "تعلم بسرعة كل ما يثير فضولك",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "حوّل إدارة مخزونك",
				hero_subtitle: "من المخزون إلى المبيعات—أدر دورة المنتج كاملة رقميًا",
				hero_description:
					"تمكّن ميزة إدارة المخزون في Antrego المصدّرين والمصنّعين من إدارة المخزون بفعالية، ومشاركة كتالوجات المنتجات مع العملاء، وتسريع عملية المبيعات عبر منصة موحّدة.",
				features_title: "ميزات قوية لإدارة المخزون",
				feature_1_title: "إدارة مخزون مركزية",
				feature_1_desc:
					"أدر جميع أصنافك من لوحة واحدة. تتبّع الكميات وأرقام الدُفعات والمستودعات وتفاصيل المنتجات بسهولة.",
				feature_2_title: "كتالوج مخزون عام",
				feature_2_desc:
					"أنشئ صفحة كتالوج عامة لاستعراض منتجاتك المتاحة لعملاء محتملين حول العالم. شارك مخزونك عبر رابط بسيط.",
				feature_3_title: "تتبع الدُفعات",
				feature_3_desc: "تتبّع كل دُفعة بمعلومات تفصيلية تشمل الكميات والأبعاد والسمات المخصصة لإدارة دقيقة.",
				feature_4_title: "دعم متعدد المستودعات",
				feature_4_desc: "نظّم مخزونك عبر مستودعات ومواقع متعددة. تتبّع أماكن التخزين لكل منتج بكفاءة.",
				feature_5_title: "معرض صور للمنتج",
				feature_5_desc: "ارفع صورًا متعددة لكل صنف لتوفير وضوح بصري لعملائك وأعضاء فريقك.",
				feature_6_title: "تحويل مباشر إلى شحنة",
				feature_6_desc: "حوّل أصناف المخزون إلى شحنات بسلاسة. أنشئ فواتير أولية ومستندات الشحن مباشرة من المخزون.",
				benefits_title: "لماذا تختار Antrego لإدارة المخزون؟",
				benefit_1: "زيادة ظهور منتجاتك للمشترين حول العالم",
				benefit_2: "تقليل الوقت المصروف على التتبع اليدوي للمخزون",
				benefit_3: "تبسيط الانتقال من المخزون إلى المبيعات",
				benefit_4: "تزويد العملاء بمعلومات مخزون فورية",
				benefit_5: "دعم لأكثر من 15 لغة للوصول إلى أسواق دولية",
				benefit_6: "تكامل مع أنظمة الشحن والفوترة",
				workflow_title: "كيف تعمل",
				step_1_title: "أضِف منتجاتك",
				step_1_desc: "أنشئ أصناف مخزون بمعلومات تفصيلية تشمل بيانات المنتج والكميات والمستودعات والصور.",
				step_2_title: "شارِك كتالوجك",
				step_2_desc: "أنشئ رابطًا عامًا لكتالوج مخزونك يمكن للعملاء المحتملين عرضه في أي وقت.",
				step_3_title: "استقبل الاستفسارات",
				step_3_desc: "يمكن للعملاء الاطلاع على منتجاتك المتاحة والتواصل معك مباشرة للطلبات والعروض.",
				step_4_title: "حوّل إلى مبيعات",
				step_4_desc: "أنشئ بسهولة فواتير أولية وشحنات من أصناف المخزون لتلبية طلبات العملاء.",
				cta_title: "هل أنت مستعد لتحديث إدارة مخزونك؟",
				cta_button: "ابدأ مجانًا",
				cta_subtitle: "لا حاجة لبطاقة ائتمان • الإعداد خلال دقائق",
			},
			access_potential_customers: "الوصول السريع إلى العملاء المحتملين",
			desc: "تم تصميم Antrego خصيصًا للمصدرين والمصنعين، حيث يسرع عمليات البيع والتسويق الخاصة بك. قم بتنمية عملك من خلال إدارة المخزون، ومشاركة المخزون مع العملاء، وإدارة الشحنات!",
			global_market: "احجز مكانك في السوق العالمية بدعم من 15 لغة مختلفة",
			main_title: "الحل من الجيل التالي للمبيعات والتسويق",
			manage_stocks: "قم بإدارة مخزونك ومشاركته فورًا",
			speed_up_sales: "سرّع عمليات البيع",
			title: "من المخزون إلى المبيعات",
		},
		$tracking: {
			$detailPage: {
				hero_title: "تتبع الشحنات في الوقت الفعلي",
				hero_subtitle: "راقب كل حاوية في كل مرحلة",
				hero_description:
					"يوفر نظام التتبع المتقدم من Antrego رؤية كاملة لشحناتك مع تحديثات فورية وتنبيهات مؤتمتة وتقارير حالة شاملة. لن تفقد أثر حاوياتك مرة أخرى.",
				features_title: "حل تتبع متكامل",
				feature_1_title: "تتبع الحاويات المباشر",
				feature_1_desc: "تتبّع حاوياتك في الوقت الفعلي مع مواقع دقيقة وتقديرات الوصول لكل شحنة.",
				feature_2_title: "تنبيهات مؤتمتة",
				feature_2_desc:
					"استلم تنبيهات لحظية للمعالم المهمة: التحميل، المغادرة، الوصول، التخليص الجمركي، وحالة التسليم.",
				feature_3_title: "سجل الحالة",
				feature_3_desc:
					"الوصول إلى تاريخ كامل للشحنة مع سجلات تفصيلية لجميع الحركات وتغييرات الحالة والأحداث الرئيسية.",
				feature_4_title: "رؤية متعددة الأطراف",
				feature_4_desc: "شارك معلومات التتبع مع العملاء والموردين ووكلاء الجمارك. يبقى الجميع على اطلاع تلقائيًا.",
				feature_5_title: "إدارة المستندات",
				feature_5_desc: "أرفِق ووصّل جميع مستندات الشحنة بما في ذلك سندات الشحن ونماذج الجمارك والشهادات في مكان واحد.",
				feature_6_title: "تنبيهات التأخير",
				feature_6_desc: "احصل على إشعارات استباقية حول التأخيرات أو المشكلات المحتملة لتتخذ إجراءً قبل تفاقمها.",
				benefits_title: "لماذا تختار التتبع من Antrego؟",
				benefit_1: "تقليل استفسارات العملاء عبر وصول ذاتي للتتبع",
				benefit_2: "منع التأخيرات المكلفة بالمراقبة والتنبيهات الاستباقية",
				benefit_3: "تحسين رضا العملاء بتواصل شفاف",
				benefit_4: "توفير الوقت بتحديثات حالة مؤتمتة لجميع الأطراف",
				benefit_5: "تقليل المخاطر عبر رؤية فورية لحالة الشحنات",
				benefit_6: "صفحات تتبع احترافية تعزز صورة علامتك",
				workflow_title: "كيف يعمل التتبع",
				step_1_title: "أنشئ الشحنة",
				step_1_desc: "أدخل تفاصيل الشحنة بما في ذلك أرقام الحاويات والمسارات والتواريخ المتوقعة.",
				step_2_title: "تحديثات مؤتمتة",
				step_2_desc: "يقوم النظام تلقائيًا بتتبع الحاويات وتحديث الحالة مع مرورها بكل نقطة تفتيش.",
				step_3_title: "تنبيهات لأصحاب المصلحة",
				step_3_desc: "تتلقى جميع الأطراف تنبيهات فورية حول المعالم المهمة وتغييرات الحالة.",
				step_4_title: "تأكيد التسليم",
				step_4_desc: "احصل على تأكيد نهائي للتسليم مع توثيق كامل وسجل تاريخ الشحنة.",
				cta_title: "ابدأ تتبع شحناتك بثقة",
				cta_button: "ابدأ مجانًا",
				cta_subtitle: "لا حاجة لبطاقة ائتمان • ابدأ التتبع اليوم",
			},
			control_title: "تولى السيطرة على شحناتك مع Antrego.",
			real_time_alerts: "تنبيهات في الوقت الفعلي: استلم إشعارات فورية وتحديثات شاملة لحالة كل حاوية.",
			secure_data_handling: "معالجة آمنة للبيانات: قم بتنزيل، مشاركة أو تخزين بيانات شحناتك بسهولة مباشرة على المنصة.",
			tracking_description:
				"يقدم حل تتبع الحاويات من Antrego طريقة سريعة وفعالة لمراقبة شحناتك في الوقت الفعلي. تحكم في شحناتك وأدهش شركاءك بتحديثات مفصلة ومحترفة.",
			tracking_title: "تتبع شحناتك بسهولة!",
		},
		cancel_anytime: "إلغاء في أي وقت",
		customize_package: "يمكنك شراء مساحة تخزين إضافية ومستخدمين وتخصيص حزمة الخدمة وفقًا لاحتياجاتك",
		free_features_1: "10 شحنات",
		free_features_2: "100 ميجابايت تخزين",
		free_features_3: "شركاء تجاريين غير محدودين",
		free_features_4: "1 مستخدم",
		free_plan: "مجاني",
		free_price: "0$",
		free_regeneration: "",
		free_title: "شهريًا",
		premium_annual_features_1: "20 مستخدمين",
		premium_annual_features_2: "100 شريك",
		premium_annual_features_3: "1000 شحنات",
		premium_annual_features_4: "1000 فواتير",
		premium_annual_price: "83.25$",
		premium_annual_regeneration: "سيتم التجديد سنويًا مقابل 999$",
		premium_annual_title: "سنويًا",
		premium_monthly_features_1: "شحنات غير محدودة",
		premium_monthly_features_2: "شركاء تجاريين غير محدودين",
		premium_monthly_features_3: "2 جيجابايت تخزين",
		premium_monthly_features_4: "3 مستخدمين",
		premium_monthly_price: "99$",
		premium_monthly_regeneration: "سيتم التجديد شهريًا مقابل 99$",
		premium_monthly_title: "شهريًا",
		premium_plan: "خطة بريميوم",
		premium_plus_annual_features_1: "شحنات غير محدودة",
		premium_plus_annual_features_2: "شركاء تجاريين غير محدودين",
		premium_plus_annual_features_3: "5 جيجابايت تخزين",
		premium_plus_annual_features_4: "5 مستخدمين",
		premium_plus_annual_price: "83.25$",
		premium_plus_annual_regeneration: "سيتم التجديد سنويًا مقابل 999$",
		premium_plus_annual_title: "سنويًا",
		premium_plus_monthly_features_1: "شحنات غير محدودة",
		premium_plus_monthly_features_2: "شركاء تجاريين غير محدودين",
		premium_plus_monthly_features_3: "5 جيجابايت تخزين",
		premium_plus_monthly_features_4: "5 مستخدمين",
		premium_plus_monthly_price: "249$",
		premium_plus_monthly_regeneration: "سيتم التجديد شهريًا مقابل 249$",
		premium_plus_monthly_title: "شهريًا",
		premium_plus_plan: "بريميوم بلس",
		pricing_text: "يمكننا تلبية احتياجاتك بأفضل طريقة دون تجاوز ميزانيتك.",
		pricing_title: "تضمن Antrego تقديم أفضل حزمة وسعر لك.",
		save_percentage: "وفر 16٪ شهريًا",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "العربية",
		de: "الألمانية",
		en: "الإنجليزية",
		es: "الإسبانية",
		fr: "الفرنسية",
		hi: "الهندية",
		ind: "الإندونيسية",
		it: "الإيطالية",
		ja: "اليابانية",
		ko: "الكورية",
		pt: "البرتغالية",
		ru: "الروسية",
		tr: "التركية",
		vi: "الفيتنامية",
		zh: "الصينية",
	},
	$message: {
		cannot_delete_verified_partner: "لا يمكنك حذف شريك معتمد.",
		confirm: "هل أنت متأكد من {function}؟",
		created: "تم إنشاء {item}.",
		deleted: "تم حذف {item}.",
		edited: "{item} تم تعديله.",
		error_on_view_file: "حدث خطأ أثناء عرض الملف.",
		file_oversize: "يجب أن يكون حجم الملف كحد أقصى {size}.",
		invalid: "{item} غير صالح",
		migrated: "تم نقل {item}. ({value})",
		process_has_been_started: "تم بدء {item}.",
		saved: "{item} تم حفظه.",
		sent: "تم إرسال {item}.",
		sent_email: "تم إرسال البريد الإلكتروني. ({value})",
		sign_in_failed: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
		unsupported_file_type: "نوع الملف غير مدعوم",
		updated: "تم تحديث {item}.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego - منصة إدارة لوجستية متكاملة للمُصدّرين والمُستوردين ووكلاء الشحن. تتبع الشحنات لحظيًا، وأدر المخزون، وأنشئ الفواتير، وأتمت المستندات. وفّر 40% من الوقت بفضل الحلول الرقمية. جرّب مجانًا!",
		stock_feature:
			"حوّل إدارة مخزونك مع Antrego. أدر المخزون، وأنشئ كتالوجات عامة، وتتبّع الدُفعات عبر المستودعات، وحوّل المخزون إلى شحنات فورًا. مثالي للمصدرين والمصنّعين.",
		tracking_feature:
			"تتبع الحاويات والشحنات في الوقت الفعلي مع Antrego. تحديثات مباشرة، تنبيهات مؤتمتة، سجل حالة كامل، ورؤية متعددة الأطراف. لن تفقد أثر شحناتك.",
		pdf_feature:
			"منشئ مستندات PDF احترافي للوجستيات. صمّم فواتير وفواتير أولية مخصصة بمحرر السحب والإفلات والقوالب والملء الآلي للبيانات. أنشئ مستندات رائعة خلال دقائق.",
		benefits_feature:
			"اكتشف مزايا منصة Antrego. لوحة مركزية، دقة أعلى، توفير للوقت، تعاون الفرق، خفض التكاليف، وقابلية التوسع. حوّل عملياتك اللوجستية اليوم.",
		contact:
			"تواصل مع Antrego - تواصل مع فريقنا للاستفسارات أو العروض التوضيحية أو الدعم. نحن هنا لمساعدتك في تحويل عملياتك اللوجستية.",
		sign_in:
			"تسجيل الدخول إلى Antrego - ادخل إلى لوحة التحكم اللوجستية لإدارة الشحنات وتتبع الحاويات وإنشاء الفواتير والتعاون مع فريقك. بوابة دخول آمنة.",
		sign_up:
			"إنشاء حساب في Antrego - أنشئ حسابك المجاني لبدء إدارة العمليات اللوجستية. احصل على 10 شحنات مجانية شهريًا. لا حاجة لبطاقة ائتمان.",
	},
	$pageTitles: {
		accept_invitation: "قبول الدعوة",
		benefits_feature: "مزايا المنصة - حل لوجستي متكامل",
		company_profile: "ملف الشركة",
		contact: "تواصل معنا - تواصل مع فريق Antrego",
		home: "الرئيسية",
		landing_page: "إدارة جميع عمليات الشحن الخاصة بك بسهولة وبشكل رقمي",
		partners: "الشركاء",
		pdf_editor: "محرر PDF",
		pdf_feature: "منشئ مستندات PDF - فواتير احترافية",
		product_details: "تفاصيل المنتج",
		product_groups: "مجموعات المنتجات",
		products: "المنتجات",
		proforma_invoices: "الفواتير المبدئية",
		shipment_details: "تفاصيل الشحنة",
		shipments: "الشحنات",
		sign_in: "تسجيل الدخول",
		sign_up: "التسجيل",
		stock_details: "تفاصيل المخزون",
		stock_feature: "إدارة المخزون - حوّل مخزونك",
		stocks: "مخزون",
		subscription: "الاشتراك",
		tracking_feature: "تتبع الشحنات - مراقبة الحاويات لحظيًا",
		user_profile: "ملف المستخدم",
	},
	$partnershipStatusTooltip: {
		createdHereDescription: "ليسوا شركاء مسجلين، لقد أنشأت ملفهم الشخصي على منصتنا، لذلك يمكنك عرض وتعديل معلوماتهم.",
		createdHereTitle: "تم إنشاؤه هنا:",
		description: "يمكنك متابعة حالة علاقتك مع شركائك. إليك الفروقات:",
		verifiedPartnersDescription: "هؤلاء الشركاء قبلوا دعوتك وسجلوا في المنصة. معلوماتهم للعرض فقط ولا يمكن تعديلها.",
		verifiedPartnersTitle: "الشركاء المعتمدون:",
	},
	$productGroup: {
		add_child: "إضافة فرع",
		add_new_product_group: "إضافة مجموعة منتجات جديدة",
		add_to_root: "إضافة إلى الجذر",
		has_children_fail_message: "لا يمكن حذف مجموعة تحتوي على فروع",
		initial_message: "استخدم هذا {0} الزر لإنشاء أول مجموعة منتجات.",
		name: "الاسم",
		number_of_product: "عدد المنتجات",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "تمت الموافقة بواسطة {name}.",
			create: "تم الإنشاء بواسطة {name}.",
			create_attachment: "تم إنشاء مرفق بواسطة {name}.",
			delete_attachment: "تم حذف المرفق بواسطة {name}.",
			demand_revise: "طلب المراجعة بواسطة {name}.",
			mark_as_processed: "تم تحديده على أنه تمت معالجته بواسطة {name}.",
			reject: "تم الرفض بواسطة {name}.",
			revoke: "تم الإلغاء بواسطة {name}.",
			send: "تم الإرسال بواسطة {name} إلى المستلم للتقييم.",
			update: "تم التحديث بواسطة {name}.",
			update_attachment: "تم تحديث المرفق بواسطة {name}.",
		},
		$actions: {
			approve: "الموافقة",
			demand_revise: "طلب المراجعة",
			mark_as_approved: "تمت الموافقة",
			mark_as_processed: "تمت المعالجة",
			mark_as_rejected: "مرفوض",
			mark_as_revise_demanded: "مراجعة مطلوبة",
			mark_as_revoked: "تم الإلغاء",
			mark_as_sent: "تم الإرسال",
			reject: "الرفض",
			revoke: "الإلغاء",
			send: "الإرسال",
		},
		$status: {
			approved: "تمت الموافقة",
			pending_approval: "قيد الموافقة",
			pending_revise: "قيد المراجعة",
			processed: "تمت المعالجة",
			rejected: "مرفوض",
			revoked: "تم الإلغاء",
			template: "نموذج",
		},
		approve_confirm_message: "هل أنت متأكد من الموافقة على الفاتورة المبدئية؟",
		approve_success_message: "تمت الموافقة على الفاتورة المبدئية.",
		demand_revise_description_message: "يرجى تقديم بعض التفاصيل حول توقعاتك للمراجعة:",
		demand_revise_success_message: "تم إعادة الفاتورة المبدئية إلى المرسل للمراجعة.",
		mark_as_processed_confirm_message: "هل تؤكد تحديد الفاتورة المبدئية كمعالجة؟",
		mark_as_processed_success_message: "تم تحديد الفاتورة المبدئية كمعالجة.",
		no_attachment_text: "لم تتم إضافة أي مرفق بعد.",
		reject_confirm_message: "هل أنت متأكد من رفض الفاتورة المبدئية؟",
		reject_success_message: "تم رفض الفاتورة المبدئية.",
		revoke_confirm_message: "هل أنت متأكد من إلغاء الفاتورة المبدئية؟",
		revoke_success_message: "تم إلغاء الفاتورة المبدئية.",
		send_confirm_message: "هل تؤكد إرسال الفاتورة المبدئية إلى المستلم؟",
		send_success_message: "تم إرسال الفاتورة المبدئية.",
	},
	$seoTitles: {
		landing_page: "Antrego | برنامج إدارة اللوجستيات - تتبع، إدارة، أتمتة",
		stock_feature: "برنامج إدارة المخزون | نظام تتبع المخزون | Antrego",
		tracking_feature: "برنامج تتبع الشحنات في الوقت الحقيقي | تتبع الحاويات | Antrego",
		pdf_feature: "مولد الفاتورة المبدئية | محرر PDF للوجستيات | Antrego",
		benefits_feature: "فوائد منصة لوجستيات كاملة | حل شامل متكامل | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "يوجد بالفعل اشتراك لهذه الوحدة.",
		bad_request: "طلب غير صالح",
		code_already_used: "تم استخدام الكود بالفعل.",
		container_status_not_available: "حالة الحاوية غير متاحة.",
		existing_email_warning: "البريد الإلكتروني موجود بالفعل.",
		existing_employee_error: "تمت إضافة هذا المستخدم بالفعل إلى شركتك.",
		existing_employee_for_email_warning: "تم إرسال كود الدعوة إلى هذا البريد الإلكتروني بالفعل",
		existing_invitation_warning: "تم إرسال كود الدعوة إلى هذا البريد الإلكتروني بالفعل.",
		existing_token_already_have_time: "الرمز الحالي يحتوي بالفعل على وقت كافٍ للاستخدام.",
		existing_user: "المستخدم موجود بالفعل.",
		five_min_reset_password_mail: "يجب عليك الانتظار لمدة 5 دقائق على الأقل بعد طلب إعادة تعيين كلمة المرور.",
		forbidden: "ممنوع",
		have_no_corporation: "ليس لديك مؤسسة",
		have_no_custom_agency: "ليس لديك وكالة جمارك",
		have_no_employee: "ليس لديك موظف",
		instance_can_no_delete_existing_booking_code: "لا يمكن حذف الكيان بسبب وجود كود حجز.",
		instance_cannot_delete: "لا يمكن حذف الكيان.",
		instance_not_found: "لم يتم العثور على الكيان.",
		internal_server_error: "خطأ في الخادم الداخلي",
		invalid_current_password: "كلمة المرور الحالية غير صالحة.",
		invalid_identifier_or_password: "معرف أو كلمة مرور غير صالحة",
		invalid_invitation_code: "كود الدعوة غير صحيح.",
		invalid_moving_request: "طلب التنقل غير صالح",
		invalid_operation: "عملية غير صالحة",
		invalid_refresh_token: "رمز التحديث غير صالح.",
		invalid_unit: "وحدة غير صالحة",
		invitation_accepting_is_due_to_the_admin: "قبول الدعوة يعود إلى المسؤول.",
		invitation_already_discarded: "تم تجاهل الدعوة بالفعل.",
		invitation_already_used: "تم استخدام الدعوة بالفعل.",
		invitation_has_been_used: "تم استخدام الدعوة.",
		invitation_not_exist_email: "الدعوة لا تحتوي على البريد الإلكتروني.",
		invitation_not_for_company: "هذه الدعوة ليست لشركة.",
		invitation_not_for_custom_agency: "هذه الدعوة ليست لوكالة الجمارك.",
		invitation_not_found: "لم يتم العثور على الدعوة.",
		invitation_not_valid: "الدعوة لم تعد صالحة.",
		link_has_been_expired: "انتهت صلاحية الرابط.",
		link_not_be_used_anymore: "قد لا يمكن استخدام هذا الرابط بعد الآن",
		missing_required_fields: "الحقول المطلوبة مفقودة.",
		no_employee_found: "لم يتم العثور على موظف",
		no_proper_partner_found: "لم يتم العثور على شريك مناسب.",
		not_acceptable: "غير مقبول",
		not_allowed_action: "غير مسموح لك بتنفيذ هذا الإجراء.",
		not_allowed_use_api: "غير مسموح لك باستخدام هذه الواجهة.",
		not_found: "غير موجود",
		not_have_purchase_subscription:
			"لقد وصل اشتراكك إلى الحد الأقصى من التعريفات. للتمكن من إضافة المزيد، يرجى ترقية خطة اشتراكك",
		not_permitted_use_api: "غير مسموح لك باستخدام هذه الواجهة.",
		own_invitation_cannot_accept: "لا يمكنك قبول دعوتك الخاصة.",
		parent_group_not_found: "لم يتم العثور على المجموعة الأصلية",
		partnerId_required: "مطلوب معرف الشريك.",
		partnership_already_exists: "تمت إضافة الشريك بالفعل.",
		password_cant_involve_space_char: "لا يمكن أن تحتوي كلمة المرور على مسافة.",
		password_min_chars_least: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
		payment_required: "يرجى الاشتراك في هذه العملية.",
		paytr_integration_error: "حدثت مشكلة في بنية الدفع. سيتم حلها في أقرب وقت ممكن.",
		ports_are_required: "الموانئ مطلوبة.",
		product_group_tree_not_found: "لم يتم العثور على شجرة مجموعة المنتجات",
		proforma_invoice_action_not_available: "حالة الفاتورة المبدئية غير متاحة لهذا الإجراء.",
		proforma_invoice_template_update: "يجب أن تكون الفاتورة المبدئية نموذجًا ليتم تحديثها.",
		shipment_email_not_exist: "يرجى إدخال بريد إلكتروني صالح.",
		shipment_method_is_required: "طريقة الشحن مطلوبة.",
		shipping_term_is_required: "شروط الشحن مطلوبة.",
		someone_else_uses_this_email: "شخص آخر يستخدم هذا البريد الإلكتروني.",
		someone_else_uses_this_username: "شخص آخر يستخدم هذا الاسم المستخدم.",
		something_went_wrong: "حدث خطأ ما",
		type_can_be_abstract_company: '"type" يمكن أن يكون فقط "abstract_company"',
		unauthorized: "غير مصرح",
		undefined_result: "نتيجة غير معرفة",
		unexpected_error_occurred: "حدث خطأ غير متوقع",
		unit_already_added: "تمت إضافة الوحدة بالفعل.",
		user_already_employee: "المستخدم هو بالفعل موظف.",
		user_already_exists: "المستخدم موجود بالفعل في شركة.",
		user_does_not_exist: "المستخدم غير موجود.",
		user_not_found: "لم يتم العثور على المستخدم.",
		username_min_chars_error: '"username" يجب أن يكون 6 أحرف على الأقل.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "تمت إضافة مركبة بواسطة {name}.",
				delete_container: "تم حذف مركبة بواسطة {name}.",
				update_container: "تم تحديث مركبة بواسطة {name}.",
			},
			create: "تم الإنشاء بواسطة {name}.",
			create_attachment: "تمت إضافة مرفق بواسطة {name}.",
			create_container: "تمت إضافة حاوية بواسطة {name}.",
			delete_attachment: "تم حذف مرفق بواسطة {name}.",
			delete_container: "تم حذف حاوية بواسطة {name}.",
			update: "تم التحديث بواسطة {name}.",
			update_attachment: "تم تحديث مرفق بواسطة {name}.",
			update_container: "تم تحديث حاوية بواسطة {name}.",
		},
		$containerStatus: {
			arrived: "وصلت",
			off_load: "تم التفريغ",
			on_load: "محملة",
			on_way: "في الطريق",
			reserved: "محجوزة",
		},
		$method: {
			aerial: "جوي",
			land: "بري",
			railway: "سكة حديدية",
			sea: "بحري",
		},
		$vehicle: {
			license_number: "رقم اللوحة",
		},
		archiving_success_message: "تم أرشفة الشحنة.",
		leave_message: "اترك رسالتك أو تعليقك",
		no_booking_info: "لم يتم تعيين معلومات الحجز حتى الآن. استخدم {0} الزر لإضافة.",
		no_transportation_info: "لم يتم تعيين معلومات التفاصيل حتى الآن. استخدم {0} الزر للتعيين.",
		un_archiving_success_message: "تم إلغاء أرشفة الشحنة.",
	},
	$shortening: {
		number: "رقم",
	},
	$socialMedia: {
		facebook: "فيسبوك",
		instagram: "انستغرام",
		linked_in: "لينكدإن",
		twitter: "تويتر",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "لم يتم تجديد اشتراكك. يرجى التحقق من طريقة الدفع الخاصة بك.",
			fail: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقًا. إذا استمرت المشكلة، يرجى الإبلاغ عن ذلك عبر إرسال بريد إلكتروني إلى info@antrego.net.",
			ok: "تم بدء عملية الشراء. سيتم إخطارك بنتيجة العملية عبر البريد الإلكتروني. سيتم بدء اشتراكك عند اكتمال الدفع بنجاح.",
			payment_process_is_ongoing:
				"عملية الدفع جارية. سيتم إخطارك بنتيجة العملية عبر البريد الإلكتروني. سيتم بدء اشتراكك عند اكتمال الدفع بنجاح.",
			success: "تم إنشاء اشتراكك بنجاح. يمكنك البدء في استخدام Antrego بسهولة.",
			try_to_get_paid_again: "انتهت صلاحية اشتراكك. انقر هنا للتجديد.",
			unsubscribed: "تم إلغاء الاشتراك",
			you_dont_have_any_subscription:
				"ليس لديك أي اشتراكات. يرجى اختيار حزمة من صفحة الاشتراك والبدء في استخدامها بسهولة.",
			you_dont_have_any_subscription_text: "اختر خطة الاشتراك الأنسب لك واستفد من جميع الفرص المتاحة.",
			you_dont_have_any_subscription_title: "حقق المزيد مع خططنا",
		},
	},
	$unit: {
		acres: "فدان",
		boxes: "صناديق",
		centimeter: "سنتيمتر",
		cubic_meter: "متر مكعب",
		dozen: "دزينة",
		feet: "قدم",
		fluid_ounces: "أوقية سائلة",
		gallons: "جالونات",
		gram: "غرام",
		hectare: "هكتار",
		inches: "بوصة",
		kilogram: "كيلوغرام",
		kilometer: "كيلومتر",
		liter: "لتر",
		meter: "متر",
		miles: "أميال",
		milligram: "ملليغرام",
		milliliter: "ملليلتر",
		millimeter: "ملليمتر",
		ounces: "أوقية",
		pallets: "منصات",
		pieces: "قطع",
		pounds: "رطل",
		quarts: "كوارتر",
		square_feet: "قدم مربع",
		square_inches: "بوصة مربعة",
		square_kilometer: "كيلومتر مربع",
		square_meter: "متر مربع",
		square_miles: "أميال مربعة",
		square_yards: "ياردة مربعة",
		ton: "طن",
		yards: "ياردات",
	},
	$validation: {
		email: "يرجى إدخال بريد إلكتروني صالح",
		invalid: "{item} غير صالح",
		max_length: "{item} يجب أن يكون أقل من {length} حرفًا",
		min_length: "{item} يجب أن يكون أطول من {length} حرفًا",
		must_length: "{item} يجب أن يكون {length} حرفًا",
		only_number: "{item} يجب أن يكون رقمًا",
		password_repeat_warning: "إعادة كلمة المرور ليست مثل كلمة المرور الجديدة.",
		required: "{item} مطلوب",
		required_for_default_language: "{item} مطلوب للغة الافتراضية للشركة.",
		you_must_approve_distance_sales_agreement: "يجب الموافقة على عقد المبيعات عن بُعد",
	},
	about: "حول",
	accept_invitation: "قبول الدعوة",
	accept_invitation_success_message: "تم استخدام الدعوة بنجاح.",
	accessibility: "الوصول",
	actions: "الإجراءات",
	active: "نشط",
	activities: "الأنشطة",
	add: "إضافة",
	add_attribute: "إضافة سمة",
	add_from_stock: "أضف من المخزون",
	add_images: "إضافة صورة",
	add_item: "إضافة {item}",
	add_manually: "أنشئ هنا",
	add_new_employee: "إضافة موظف جديد",
	add_new_packaging: "إضافة عبوة جديدة",
	add_new_product: "إضافة منتج جديد",
	add_new_stock: "إضافة مخزون جديد",
	add_new_warehouse: "أضف مستودع جديد",
	add_stock_batch: "إضافة دفعة مخزون",
	add_template: "إضافة قالب",
	add_variant: "إضافة نوع",
	address: "العنوان",
	again: "مرة أخرى",
	alert: "تنبيه",
	already_have_employee_message: "أنت بالفعل موظف في شركة.",
	amount: "المبلغ",
	approve: "الموافقة",
	archive: "أرشفة",
	attachment: "المرفق",
	attachments: "المرفقات",
	attribute: "السمة",
	attributes: "سمة",
	auto_attached_pdf: "ملف PDF المرفق تلقائيًا",
	auto_detect: "كشف تلقائي",
	available: "متاح",
	bank: "البنك",
	basket: "السلة",
	basket_empty: "سلتك فارغة",
	batch: "دفعة",
	batch_no: "رقم الدفعة",
	batches: "دفعات المخزون",
	benefits: "الفوائد",
	billed_to: "فاتورة إلى",
	booking: "الحجز",
	booking_code: "رمز الحجز",
	booking_details: "تفاصيل الحجز",
	boolean: "منطقي",
	business_partner: "شريك تجاري",
	business_partners: "الشركاء التجاريون",
	cancel: "إلغاء",
	carrier: "ناقل",
	change_password: "تغيير كلمة المرور",
	checking_invitation_code_message: "جارٍ التحقق من كود الدعوة",
	checkout: "الدفع",
	choose_image: "اختر صورة",
	choose_your_plan: "اختر خطتك",
	clear: "مسح",
	clear_basket: "تفريغ السلة",
	click_to_play_the_video: "انقر لتشغيل الفيديو",
	close: "إغلاق",
	code: "الكود",
	commercial: "تجاري",
	commercial_partner: "شريك تجاري",
	commercial_partners: "الشركاء التجاريون",
	companies: "الشركات",
	company: "الشركة",
	company_address: "عنوان الشركة",
	company_name: "اسم الشركة",
	company_profile: "ملف الشركة",
	configuration: "التكوين",
	confirm: "تأكيد",
	confirm_distance_selling_agreement: "تأكيد عقد المبيعات عن بُعد.",
	consult_us: "استشرنا",
	contact: "اتصل",
	contact_info: "معلومات الاتصال",
	contact_text: "اطمئن، سوف نتواصل معك في أقرب وقت ممكن.",
	contact_title: "استشرنا، وسهل عملياتك",
	contact_to_us: "اتصل بنا",
	container: "الحاوية",
	container_no: "رقم الحاوية",
	containers: "الحاويات",
	content: "المحتوى",
	contract: "العقد",
	copy_link: "نسخ الرابط",
	corporation: "شركة",
	countries: "البلدان",
	country: "البلد",
	create: "إنشاء",
	create_a_new_account: "إنشاء حساب جديد",
	create_company: "إنشاء شركة",
	create_document: "إنشاء مستند",
	create_shipment: "إنشاء شحنة",
	created_at: "تم الإنشاء في",
	created_here: "تم إنشاؤه هنا",
	credit_card_info: "معلومات بطاقة الائتمان",
	credit_card_no: "رقم بطاقة الائتمان",
	currencies: "العملات",
	currency: "العملة",
	current_password: "كلمة المرور الحالية",
	current_plan: "الخطة الحالية",
	customer_company_address: "عنوان شركة العميل",
	customer_company_name: "اسم شركة العميل",
	customs: "الجمارك",
	customs_agencies: "وكالات الجمارك",
	customs_agency: "وكالة الجمارك",
	cvv: "CVV",
	daily: "يومي",
	damaged: "تالف",
	dashboard: "لوحة التحكم",
	date: "التاريخ",
	date_input: "حقل التاريخ",
	day: "يوم",
	default: "افتراضي",
	default_language: "اللغة الافتراضية",
	delete: "حذف",
	delete_account: "حذف الحساب",
	delete_confirm_message: "هل تؤكد الحذف؟",
	delete_document: "حذف المستند",
	delete_template: "حذف القالب",
	description: "الوصف",
	detail: "التفاصيل",
	dimensions: "الأبعاد",
	discard: "تجاهل",
	discover_all_benefits: "اكتشف جميع المزايا",
	distance_sales_agreement: "عقد المبيعات عن بُعد",
	document: "مستند",
	document_actions: "إجراءات المستند",
	document_added: "تمت إضافة الوثيقة",
	document_creator: "منشئ المستندات",
	document_manager: "مدير المستندات",
	document_name: "اسم المستند",
	document_number: "رقم المستند",
	document_overwrite: "احفظ التعديلات كمستند جديد",
	document_save_info: "سيتم حفظ هذا المستند داخل هذه الفاتورة الأولية فقط.",
	document_updated: "تم تحديث الوثيقة",
	download: "تنزيل",
	download_pdf: "تحميل PDF",
	download_template: "تنزيل القالب",
	edit: "تعديل",
	edit_attribute: "تعديل الخاصية",
	edit_description: "تحرير الوصف",
	edit_document: "تحديث المستند",
	edit_item: "تعديل {item}",
	edit_packaging: "تعديل العبوة",
	edit_product: "تعديل المنتج",
	edit_profile: "تعديل الملف الشخصي",
	edit_stock: "تعديل المخزون",
	edit_stock_batch: "تعديل دفعة المخزون",
	edit_template: "تحديث القالب",
	edit_variant: "تعديل المتغير",
	edit_your_profile_picture: "عدل صورتك الشخصية",
	email: "البريد الإلكتروني",
	employee: "الموظف",
	employee_type: "نوع الموظف",
	employees: "الموظفون",
	empty_data_warning: "لا توجد بيانات في هذا المجال حتى الآن. يمكنك البدء في استكشاف المنصة باستخدام بيانات نموذجية.",
	estimated_arrival_day: "يوم الوصول المتوقع",
	expense: "النفقات",
	expenses: "النفقات",
	expires_at: "ينتهي في",
	explore_pdf_editor: "أنشئ المستندات فورًا",
	explore_stock_management: "إتقان إدارة المخزون",
	explore_tracking_features: "تتبع لحظي",
	exported_containers: "الحاويات المصدرة",
	fail: "فشل",
	failed: "فشل",
	faq: "الأسئلة الشائعة",
	feedback: "التغذية الراجعة",
	file: "الملف",
	file_name: "اسم الملف",
	file_preview: "معاينة الملف",
	file_processing_error_message: "خطأ في معالجة الملف: {error}",
	file_read_error_message: "خطأ في قراءة الملف",
	file_view: "عرض الملف",
	filter: "التصفية",
	first_name: "الاسم الأول",
	first_name_last_name: "الاسم الأول واللقب",
	fixed_value: "قيمة ثابتة",
	forget_password: "نسيت كلمة المرور",
	forget_password_message: "هل نسيت كلمة المرور الخاصة بك؟",
	forget_password_subtitle: "يرجى إدخال عنوان بريدك الإلكتروني لإعادة تعيين كلمة المرور.",
	format: "التنسيق",
	free: "مجاني",
	from: "من",
	general: "افتراضي",
	get_started_now: "ابدأ الآن",
	give_us_feedback: "أرسل لنا ملاحظاتك",
	go_to_panel: "الذهاب إلى لوحة التحكم",
	go_to_proforma: "اذهب إلى الفاتورة الأولية",
	go_to_shipment: "اذهب إلى الشحنة",
	gross: "إجمالي",
	height: "الارتفاع",
	hide: "إخفاء",
	hide_all: "إخفاء الكل",
	home_page: "الصفحة الرئيسية",
	i_have_invitation_code: "لدي كود دعوة",
	image_delete: "حذف الصورة",
	images: "صور",
	import_excel: "استيراد من إكسل",
	import_fail_message: "فشل الاستيراد: {error}",
	import_success_message: "تم استيراد {count} منتج بنجاح{skipped}.",
	imported_containers: "الحاويات المستوردة",
	in_progress: "جاري التنفيذ",
	in_stock: "متوفر",
	incoming: "الوارد",
	incoming_shipments: "الشحنات الواردة",
	initial: "البدء",
	inputs: "المحتوى",
	invitation: "الدعوة",
	invitation_code: "كود الدعوة",
	invitation_mail_sent: "تم إرسال دعوة عبر البريد الإلكتروني",
	invitations: "الدعوات",
	invoice: "فاتورة",
	invoice_no: "رقم الفاتورة",
	join: "انضم",
	join_company: "انضم إلى الشركة",
	language: "اللغة",
	language_options: "خيارات اللغة",
	last_name: "اللقب",
	last_one_year: "آخر سنة",
	latitude: "خط العرض",
	learn_more: "اعرف المزيد",
	left_a_comment: "ترك تعليقًا",
	length: "الطول",
	link_copied: "تم نسخ الرابط",
	link_copy_failed: " فشل نسخ الرابط",
	loading_country: "بلد التحميل",
	loading_point: "نقطة التحميل",
	loading_port: "ميناء التحميل",
	log_in: "تسجيل الدخول",
	logo: "الشعار",
	longitude: "خط الطول",
	lot_no: "رقم الدفعة",
	mail_sent: "تم إرسال البريد الإلكتروني",
	make_visible: "اجعلها مرئية",
	manage_profile: "إدارة ملفك في Antrego",
	mass: "الكتلة",
	measurements: "القياسات",
	merge_partner_description:
		"يمكن دمج الشركة التي تم إنشاؤها هنا مع الشريك المعتمد الحالي عندما تنشئ ملفًا شخصيًا على Antrego.",
	message: "الرسالة",
	message_company_create: "تم إنشاء الشركة.",
	message_company_join: "يرجى إدخال رمز الدعوة.",
	message_company_joined: "لقد انضممت إلى الشركة",
	message_employee_delete: "تم حذف الموظف.",
	message_employee_save: "تم حفظ الموظف.",
	message_join_company: "أدخل رمزك للانضمام إلى شركة موجودة",
	method: "الطريقة",
	migrate: "نقل",
	migrate_partner: "نقل شركة",
	migrate_partner_description:
		"يمكن دمج الشركة التي تم إنشاؤها هنا مع الشريك المُحقق الحالي عندما يقوم بإنشاء ملف تعريف على Antrego",
	missing_product_group_sheet_message: "ورقة مجموعة المنتجات مفقودة في ملف إكسل",
	missing_product_sheet_message: "ورقة المنتج مفقودة في ملف إكسل",
	mobile_number: "رقم الهاتف المحمول",
	month: "الشهر",
	month_lowercase: "شهر",
	monthly: "شهريًا",
	multiple_select: "اختيار متعدد",
	my_profile: "ملفي الشخصي",
	my_role: "دوري",
	name: "الاسم",
	net: "صافي",
	new: "جديد",
	new_company_package: "مجاني",
	new_password: "كلمة المرور الجديدة",
	new_shipment: "شحنة جديدة",
	next: "التالي",
	no: "لا",
	no_content: "لا يوجد محتوى",
	no_entity: "لا يوجد {entityName} حتى الآن",
	no_entity_message: "قم بإنشاء {entityName} وسيتم إدراج التفاصيل هنا",
	no_image: "لا توجد صورة",
	no_product_data_message: "لم يتم العثور على بيانات المنتج في ملف إكسل",
	no_product_group_data_message: "لم يتم العثور على بيانات مجموعة المنتجات في ملف إكسل",
	no_stock_batches_found: "لم يتم العثور على دفعات مخزون",
	no_stock_matches_filters: "لا يوجد مخزون يطابق المعايير المحددة.",
	no_stocks_added_yet: "لم يتم إضافة أي مخزون بعد — الرجاء اختيار واحد أو إضافته.",
	no_text: "لا يوجد نص",
	no_valid_products_message: "لم يتم العثور على منتجات صالحة. يجب أن يكون لكل منتج اسم باللغة الافتراضية ({language}).",
	not_found_in_stock: "لا يمكن العثور على منتج بالمخزون باستخدام عوامل التصفية الحالية.",
	not_found_page_message: "عذرًا، لا يمكنني العثور على هذه الصفحة :(",
	not_set: "غير محدد",
	note: "ملاحظة",
	notes: "ملاحظات",
	number_of_rows: "عدد الصفوف",
	ok: "موافق",
	operation_fail: "فشل العملية",
	option: "خيار",
	options: "الخيارات",
	other: "أخرى",
	out_of_stock: "غير متوفر",
	outgoing: "الصادر",
	outgoing_shipments: "الشحنات الصادرة",
	packages: "الحزم",
	packaging: "العبوة",
	packing_list_title: "قائمة التعبئة",
	parent_group: "المجموعة الأم",
	partner: "الشريك",
	partners: "الشركاء",
	partnership_status: "حالة الشراكة",
	passive: "غير نشط",
	password: "كلمة المرور",
	pay: "الدفع",
	payback: "الاسترداد",
	payback_confirm_message: "هل تؤكد الاسترداد؟",
	payback_warning_message: "إذا تابعت، سيتم إنهاء اشتراكك.",
	payment: "الدفع",
	payment_amount: "مبلغ الدفع",
	payment_awaited: "في انتظار الدفع",
	payment_history: "سجل الدفع",
	payment_info: "معلومات الدفع",
	payment_information: "معلومات الدفع",
	payment_success: "تم الدفع بنجاح",
	payment_summary: "ملخص الدفع",
	payment_will_be_made_3d_secure: "*سيتم الدفع باستخدام 3D Secure.",
	pdf_attached_message: "تم إرفاق ملف PDF بنجاح",
	pdf_editor: "محرر PDF",
	pdf_name: "اسم PDF",
	pending_invitations: "الدعوات المعلقة",
	per_month: "شهريًا",
	phone_number: "رقم الهاتف",
	pieces: "قطع",
	plate_numbers: "أرقام اللوحات",
	please_click_add_option: "لقد كتبت خيارًا ولكنك لم تضفه. يرجى إضافته أو مسحه.",
	prefix: "بادئة",
	premium: "بريميوم",
	premium_plus: "بريميوم بلس",
	preview: "معاينة",
	previous: "السابق",
	price: "السعر",
	pricing: "التسعير",
	process: "العملية",
	product: "المنتج",
	product_details: "تفاصيل المنتج",
	product_group: "مجموعة المنتجات",
	product_group_name: "اسم مجموعة المنتجات",
	product_group_not_found_message: 'لم يتم العثور على مجموعة المنتج "{group}". يتم تخطي المنتج ذو الكود "{code}".',
	product_groups: "مجموعات المنتجات",
	product_images: "صور المنتج",
	product_name: "اسم المنتج",
	products: "المنتجات",
	profile: "الملف الشخصي",
	proforma_invoice: "الفاتورة المبدئية",
	proforma_invoices: "الفواتير المبدئية",
	proforma_number: "رقم الفاتورة المبدئية",
	proforma_options: "خيارات الفاتورة الشكلية",
	proforma_title: "فاتورة أولية",
	purchase: "الشراء",
	quantity: "الكمية",
	quantity_warning: "نظرًا لتغييرك لقيمة إجمالي المخزون مسبقًا، لن يتم حساب الإجمالي تلقائيًا.",
	ready_to_import: "جاهز للاستيراد",
	receiver: "المستلم",
	receiver_company: "شركة المستلم",
	receiver_customs_agency: "وكالة الجمارك المستلم",
	redirection_to_home_link: "الصفحة الرئيسية",
	redirection_to_home_message: "يمكنك أيضًا الانتقال إلى ",
	redirection_to_sign_in_message: "هل تملك حسابًا؟",
	redirection_to_sign_up_message: "هل لا تملك حسابًا حتى الآن؟",
	reload: "إعادة التحميل",
	renewal: "التجديد",
	repaid: "تم السداد",
	reserved: "محجوز",
	reset_password: "إعادة تعيين كلمة المرور",
	returned: "تم الإرجاع",
	route: "المسار",
	rows_per_page: "الصفوف لكل صفحة",
	sales: "المبيعات",
	save: "حفظ",
	save_as_document: "حفظ كمستند",
	save_as_new_document: "حفظ كمستند جديد",
	save_as_new_template: "حفظ كقالب جديد",
	save_as_template: "حفظ كقالب",
	save_changes: "حفظ التغييرات",
	save_pdf_to_attachments: "حفظ PDF في المرفقات",
	saved_card_info: "معلومات البطاقة المحفوظة",
	search: "بحث",
	select: "اختر",
	select_a_file_to_preview: "اختر ملفًا للمعاينة",
	select_document: "اختر الوثيقة",
	select_document_to_overwrite: "حدد المستند للكتابة فوقه",
	select_file: "اختر ملف",
	select_file_place_holder: "يرجى اختيار صورة",
	select_language: "اختر اللغة",
	select_template: "اختر القالب",
	select_template_to_overwrite: "حدد القالب للكتابة فوقه",
	selected: "تم الاختيار",
	selected_partner: "الشريك المختار",
	send: "إرسال",
	send_again: "إعادة الإرسال",
	send_email: "إرسال بريد إلكتروني",
	send_feedback: "إرسال ملاحظات",
	send_invitation: "إرسال دعوة",
	sender: "المرسل",
	sender_company: "شركة المرسل",
	sender_customs_agency: "وكالة الجمارك المرسل",
	separate_gross: "أضف القياسات الإجمالية",
	settings: "الإعدادات",
	shipment: "الشحنة",
	shipment_code: "رمز الشحنة",
	shipment_details: "تفاصيل الشحنة",
	shipment_method: "طريقة الشحن",
	shipment_type: "نوع الشحن",
	shipments: "الشحنات",
	shipments_filter: "تصفية الشحنات",
	shipped: "تم الشحن",
	shipping_term: "شروط الشحن",
	shipping_terms: "شروط الشحن",
	show: "عرض",
	show_all: "عرض الكل",
	show_company_stock_page: "عرض صفحة مخزون الشركة",
	show_in_stocks: "عرض في صفحة المخزون",
	sign_in: "تسجيل الدخول",
	sign_out: "تسجيل الخروج",
	sign_out_confirm_message: "هل تؤكد تسجيل الخروج؟",
	sign_out_success_message: "وداعًا.",
	sign_up: "التسجيل",
	sizes: "مقاسات",
	social_media: "وسائل التواصل الاجتماعي",
	social_media_account: "حساب وسائل التواصل الاجتماعي",
	start_time: "وقت البدء",
	status: "الحالة",
	stock: "مخزون",
	stock_details: "تفاصيل المخزون",
	stock_images: "صور المخزون",
	stock_status: "حالة المخزون",
	stocks: "المخزون",
	stocks_url: "رابط المخزون",
	subscribe: "اشترك",
	subscription: "الاشتراك",
	subscription_info_message: "يمكنك الاستفادة من جميع الخدمات بشكل غير محدود خلال فترة الاشتراك.",
	subscription_warning_message: "**سيتم تخزين معلومات بطاقتك بشكل آمن وسيتم تجديد اشتراكك بانتظام ما لم تقم بإلغائه.",
	success: "نجاح",
	super: "ممتاز",
	supported_files_img: "الملفات المدعومة: ملفات JPG و PNG أقل من 20 ميجابايت",
	switch_language: "تبديل اللغة",
	switch_theme: "تبديل السمة",
	table_inputs: "محتوى الجدول",
	target: "الهدف",
	target_partner: "الشريك المستهدف",
	tax_number: "رقم الضريبة",
	template: "قالب",
	template_actions: "إجراءات القالب",
	template_added: "تمت إضافة القالب",
	template_name: "اسم القالب",
	template_overwrite: "احفظ التعديلات كقالب جديد",
	template_save_info: "سيتم عرض القوالب المحفوظة لاحقًا لاستخدامها في الفواتير الأولية والشحنات.",
	template_updated: "تم تحديث القالب",
	terms_of_sale_and_other_comments: "شروط البيع - تعليقات",
	text_input: "حقل النص",
	theme: "السمة",
	this_month: "هذا الشهر",
	this_year: "هذا العام",
	title: "العنوان",
	to: "إلى",
	toDelete: "حذف",
	total: "الإجمالي",
	total_amount: "المبلغ الإجمالي",
	total_price: "السعر الإجمالي",
	total_warning: "إذا قمت بتغيير هذه البيانات، فلن يتم حساب الإجمالي تلقائيًا بعد الآن.",
	tracking: "تتبع الشحنات",
	transaction_no: "رقم المعاملة",
	transactions: "المعاملات",
	try_for_free: "جرّب مجانًا",
	type: "النوع",
	types: "الأنواع",
	un_archive: "إلغاء الأرشفة",
	unit: "الوحدة",
	unit_price: "سعر الوحدة",
	units: "الوحدات",
	unloading_country: "بلد التفريغ",
	unloading_point: "نقطة التفريغ",
	unloading_port: "ميناء التفريغ",
	unsubscribe: "إلغاء الاشتراك",
	unsubscribe_confirm_message:
		"إذا قمت بإلغاء الاشتراك، فلن تتمكن من استخدام ميزات النظام بشكل فعال. هل أنت متأكد أنك تريد إلغاء الاشتراك؟",
	upload_new_image: "رفع صورة جديدة",
	use_code: "استخدام الكود",
	use_invitation_code: "استخدام كود الدعوة",
	use_invitation_code_description: "أدخل كود الدعوة الذي أرسل إلى بريدك.",
	use_invitation_code_success_message: "تم استخدام كود الدعوة بنجاح.",
	user_profile: "ملفي الشخصي",
	value: "القيمة",
	variant: "متغير",
	variants: "الأنواع",
	vehicle: "المركبة",
	vehicles: "المركبات",
	verified_partner: "شريك معتمد",
	verify_password: "تأكيد كلمة المرور",
	visibility: "الرؤية",
	warehouse: "المستودع",
	warehouses: "المستودعات",
	warn_unsaved_measurement: "لا تنسَ النقر على '+' لإضافة قياساتك.",
	website: "الموقع الإلكتروني",
	week: "أسبوع",
	weight: "الوزن",
	weight_kg: "الوزن (كجم)",
	welcome: "مرحبًا",
	what_we_are_doing: "ما الذي نفعله",
	width: "العرض",
	year: "عام",
	year_lowercase: "سنة",
	yearly: "سنوياً",
	yes: "نعم",
	yes_no: "نعم / لا",
	you_dont_have_any_active_subscription: "ليس لديك أي اشتراك نشط",
};
